var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbusingOfflineSecurityAgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5661 14.8418L30.3705 17.4206C30.9675 17.6859 31.3572 18.2829 31.3572 18.938V22.8353C31.3572 27.4373 28.1731 31.7409 23.8944 32.7856C19.6158 31.7409 16.4316 27.4373 16.4316 22.8353V18.938C16.4316 18.2829 16.8214 17.6859 17.4184 17.4206L23.2228 14.8418C23.6457 14.6511 24.1432 14.6511 24.5661 14.8418ZM23.8944 23.6562H18.09C18.5295 27.0725 20.8098 30.1156 23.8944 31.0692V23.6644H29.6988V18.938L23.8944 16.3592V23.6562Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2228 14.8418L17.4184 17.4206C16.8214 17.6859 16.4316 18.2829 16.4316 18.938V22.8353C16.4316 27.4373 19.6158 31.7409 23.8944 32.7856C28.1731 31.7409 31.3572 27.4373 31.3572 22.8353V18.938C31.3572 18.2829 30.9675 17.6859 30.3705 17.4206L24.5661 14.8418C24.1432 14.6511 23.6457 14.6511 23.2228 14.8418ZM23.8944 23.6562H29.6988C29.2594 27.0725 26.9791 30.1156 23.8944 31.0692V23.6644H18.09V18.938L23.8944 16.3592V23.6562Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9883 17.2634L30.2304 31.4044",
    stroke: "#141414",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 16.1602L31.2578 30.3011",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1764 30.301C35.1764 32.6022 33.311 34.4677 31.0098 34.4677C28.7086 34.4677 26.8431 32.6022 26.8431 30.301C26.8431 27.9998 28.7086 26.1344 31.0098 26.1344C33.311 26.1344 35.1764 27.9998 35.1764 30.301Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0098 25.301C28.2498 25.301 26.0098 27.541 26.0098 30.301C26.0098 33.061 28.2498 35.301 31.0098 35.301C33.7698 35.301 36.0098 33.061 36.0098 30.301C36.0098 27.541 33.7698 25.301 31.0098 25.301ZM31.0098 34.301C28.8048 34.301 27.0098 32.506 27.0098 30.301C27.0098 28.096 28.8048 26.301 31.0098 26.301C33.2148 26.301 35.0098 28.096 35.0098 30.301C35.0098 32.506 33.2148 34.301 31.0098 34.301Z",
    fill: "#141414"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9854 27.7935V30.6467",
    stroke: "#141414",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9857,
    cy: 32.6439,
    r: 0.570647,
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbusingOfflineSecurityAgent);
export default __webpack_public_path__ + "static/media/abusing_offline_security_agent.0121b68f622faade5fdf58418b495e4f.svg";
export { ForwardRef as ReactComponent };